<div class="settings-container">
    <!-- Each tab is built when first opened and then kept, so opening Settings does not build every tab at once (a
         practice with hundreds of colleagues made the whole page lag). -->
    <mat-tab-group class="fixed-header" [@tabAnimation] [selectedIndex]="selectedTabId" matTabGroupGesture
        [swipeLimitWidth]="80" [connectEdges]="true" [preserveContent]="true" (selectedIndexChange)="onTabChange($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">person</mat-icon>
                Profile
            </ng-template>
            <ng-template matTabContent><app-profile-settings></app-profile-settings></ng-template>
        </mat-tab>

        <!--  <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">card_membership</mat-icon>
                Subscription & Tokens
            </ng-template>
            <ng-template matTabContent><app-subscription-settings></app-subscription-settings></ng-template>
        </mat-tab> -->


        <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">summarize</mat-icon>
                Notes
            </ng-template>
            <ng-template matTabContent><app-note-type-settings></app-note-type-settings></ng-template>
        </mat-tab>

        <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">calendar_month</mat-icon>
                Schedule
            </ng-template>
            <ng-template matTabContent><app-schedule-settings></app-schedule-settings></ng-template>
        </mat-tab>

        <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">fact_check</mat-icon>
                Consent
            </ng-template>
            <ng-template matTabContent><app-consent-form-settings></app-consent-form-settings></ng-template>
        </mat-tab>

        <!-- Practice documents — tasks/practice-documents.md §1.4 / §7 phase 1. Beside Consent,
             which is the feature it is modelled on: a settings tab that uploads PDFs and attaches
             them to a workflow.

             NOT flagged. The Forms tab below is hidden behind `practiceFormsEnabled` because that
             is a DIFFERENT feature (the questionnaire builder) deliberately held back per
             tasks/patient-forms.md §17. The two sit side by side and neither replaces the other
             (practice-documents.md §0 decision 1), so the flag does not travel between them. -->
        <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">description</mat-icon>
                Documents
            </ng-template>
            <ng-template matTabContent><app-practice-document-settings></app-practice-document-settings></ng-template>
        </mat-tab>

        <!-- Practice forms — tasks/patient-forms.md §5.2: between Consent and Survey Template.
             HIDDEN behind environment.PRACTICE_FORMS_ENABLED (false everywhere) pending a rollout
             decision. Nothing is deleted; flipping the flag restores this tab. -->
        <mat-tab *ngIf="practiceFormsEnabled && isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">assignment</mat-icon>
                Forms
            </ng-template>
            <ng-template matTabContent><app-custom-form-settings></app-custom-form-settings></ng-template>
        </mat-tab>

        <mat-tab *ngIf="isAdmin() && !stateMode">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">quiz</mat-icon>
                Survey Template
            </ng-template>
            <ng-template matTabContent><app-survey-template-settings></app-survey-template-settings></ng-template>
        </mat-tab>

        <mat-tab *ngIf="isAdmin() && !stateMode">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">payments</mat-icon>
                Coding
            </ng-template>
            <ng-template matTabContent><app-billing-settings></app-billing-settings></ng-template>
        </mat-tab>

        <!-- HIDDEN FINANCIAL -->
        <mat-tab *ngIf="isAdmin() && !stateMode">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">point_of_sale</mat-icon>
                Tariffs & Payments (Beta)
            </ng-template>
            <ng-template matTabContent><app-accounting-settings></app-accounting-settings></ng-template>
        </mat-tab>

        <mat-tab *ngIf="isAdmin()">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">groups</mat-icon>
                MedicAI Network
            </ng-template>
            <!--
                ONE settings page, as every other tab: one heading, one hint, one accordion. The two components render
                PANELS only; a panel finds this accordion through its component's host, so one opens at a time across both.
                Contacts first (colleagues, the theatre roster), then the links that can receive shared records.
            -->
            <ng-template matTabContent>
                <div class="network-tab">
                    <div class="settings-header">
                        <h2>MEDICAI NETWORK SETTINGS</h2>
                        <p class="hint">Keep the details of the colleagues you write to, and of the anaesthetists and surgical
                            assistants you book for theatre.<ng-container *ngIf="!stateMode"> Letters you email through MedicAI meet the Protection of Personal
                            Information standards.</ng-container><ng-container *ngIf="referralsEnabled"> Link with clinicians outside MedicAI and
                            with other MedicAI practices to refer patients: they see only the records you choose to share, what
                            comes back arrives in your Inbox, and nothing reaches the patient's record until someone in your
                            practice validates it.</ng-container>
                        </p>
                    </div>
                    <mat-accordion multi="false">
                        <app-colleague-settings></app-colleague-settings>
                        <!-- The referral network (tasks/referrals.md §5.2), in this tab since 2026-09-18 (owner: "one less tab").
                             Hidden unless environment.referralsEnabled is true (fail-closed, like Forms); admins only, as the tab. -->
                        <app-referral-network-settings *ngIf="referralsEnabled"></app-referral-network-settings>
                    </mat-accordion>
                    <div class="mobile-spacer"></div>
                </div>
            </ng-template>
        </mat-tab>


        <mat-tab *ngIf="isAdmin() || newSubscription">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">show_chart</mat-icon>
                Subscriptions & Usage
            </ng-template>
            <ng-template matTabContent><app-subscription-settings [isNewSubscription]="newSubscription"></app-subscription-settings></ng-template>
        </mat-tab>



    </mat-tab-group>
</div>

<ng-template #loading>
    <div class="loader">
        <mat-spinner></mat-spinner>
        <p>Loading profile details...</p>
    </div>
</ng-template>